"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 35 35';

var DeleteCircleFilled = function DeleteCircleFilled(_ref) {
  var classes = _ref.classes;
  return _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "17.5"
  }), _react["default"].createElement("path", {
    className: classes.x,
    transform: "translate(11.5, 11.5)",
    d: "M11.7993762,11.5312286 L6.96415972,6.69662559 L11.7926274,1.86815788 C12.0601258,1.60065954 12.0601258,1.16750856 11.7926274,0.900623754 C11.5257426,0.633125415 11.0925916,0.633125415 10.8250933,0.900623754 L5.99662559,5.72909147 L1.16815788,0.900623754 C0.900659543,0.633125415 0.467508564,0.633125415 0.200623754,0.900623754 C-0.0668745846,1.16750856 -0.0668745846,1.60065954 0.200623754,1.86815788 L5.02909147,6.69662559 L0.200623754,11.5250933 C-0.0668745846,11.7925916 -0.0668745846,12.2257426 0.200623754,12.4926274 C0.333759395,12.6263766 0.509842016,12.6938647 0.684697582,12.6938647 C0.859553147,12.6938647 1.03440871,12.6263766 1.16815788,12.4926274 L5.99662559,7.66415972 L10.8318421,12.4987627 C10.9655913,12.6325119 11.1404469,12.6993865 11.3153024,12.6993865 C11.490158,12.6993865 11.6650135,12.6325119 11.7993762,12.4987627 C12.0668746,12.2318779 12.0668746,11.7987269 11.7993762,11.5312286"
  }));
};

DeleteCircleFilled.propTypes = {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired
};
var StyledDeleteCircleFilled = (0, _withStyles["default"])({
  x: {
    fill: _styles.colors.white
  }
})(DeleteCircleFilled);

var _default = (0, _createSvgIcon["default"])(StyledDeleteCircleFilled, {
  viewBox: viewBox
});

exports["default"] = _default;